var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSliders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5415 9.3335H8.45817M14.8748 9.3335H22.4582M5.5415 18.6668H14.2915M20.7082 18.6668H22.4582M14.2915 9.3335C14.2915 10.7832 13.1163 11.9585 11.6665 11.9585C10.2168 11.9585 9.0415 10.7832 9.0415 9.3335C9.0415 7.88375 10.2168 6.7085 11.6665 6.7085C13.1163 6.7085 14.2915 7.88375 14.2915 9.3335ZM20.1248 18.6668C20.1248 20.1166 18.9496 21.2918 17.4998 21.2918C16.0501 21.2918 14.8748 20.1166 14.8748 18.6668C14.8748 17.2171 16.0501 16.0418 17.4998 16.0418C18.9496 16.0418 20.1248 17.2171 20.1248 18.6668Z",
    stroke: "#7047EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSliders);
export default __webpack_public_path__ + "static/media/settings-sliders.e788e3d9f9b0c2c6003872785f342917.svg";
export { ForwardRef as ReactComponent };